<template>
  <div>
    <article>
      <div class="container">
        <section class="error-content content-block-mid">
          <h1>{{ heading }}</h1>
          <h2 v-if="subHeading">{{ subHeading }}</h2>
          <BlocksWerkenbijContentArea v-if="body" :content="{ propertyName: null, value: body }" />
        </section>
      </div>
    </article>
  </div>
</template>

<script setup lang="ts">
import type { ContentResponseModel, StatusCodePageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { body, heading, subHeading } = props.data.content as StatusCodePageResponseModel;
</script>

<style lang="scss" scoped>
.error-content {
  grid-row: 2 / 3;

  :deep(p) {
    margin-bottom: px(30);
  }

  li {
    position: relative;
    padding-left: px(24);

    &::before {
      content: '•';
      display: block;
      position: absolute;
      font-size: px(24);
      font-weight: bold;
      left: 0;
      top: 0;
      line-height: px(24);
    }
  }
}
</style>
